import { fromJS } from 'immutable';
import { find } from 'lodash';
import {
  mapLoadingToResults,
  mapLoadingCancelToResults,
} from '../../../../CommonComponents/CharitySearch/utils';
import * as actionTypes from './actionTypes';
import { fetchGrantHistorySuccessType } from '../RecommendGrant/actionTypes';

const initialState = fromJS({
  accountData: {
    isLoading: true,
    data: {},
    error: '',
  },
  currentPendingGrants: {
    isLoading: true,
    data: [],
    error: '',
    dataAvailableForNextRequest: true,
  },
  issuedGrants: {
    isLoading: true,
    data: [],
    error: '',
    dataAvailableForNextRequest: true,
  },
  isLazyLoading: false,
  initialPendingGrants: 10,
  initialIssuedGrants: 10,
  grantDashboard_data: {
    isLoadingBot: true,
    data: [],
    error: '',
    botStatusText: 'Searching for results in the data range',
    data_y3: false,
    data_y5: false,
  },
  grantDashboard_data_all: {
    isLoadingBot: false,
    data: [],
    error: '',
    botStatusText: 'Seaching for results in the data range',
    data_all_y3: false,
    data_all_y5: false,
  },
  chartData: {
    isLoading: false,
    show: false,
    data: {},
    error: '',
  },
  grantsCount: {
    isLoading: false,
    data: null,
    error: '',
  },
  additionalAccountDetails: {
    data: {
      establishedDate: 1263354667435,
    },
  },
  // search charity

  accountSelected: {
    isLoading: true,
    data: {},
    error: '',
  },
  savedCharity: {
    isLoading: true,
    error: '',
  },
  searchGemini: {
    isLoading: true,
    data: null,
    searchGeminiStringResponse: null,
    isGeminiSearch: false,
    error: '',
  },
  searchCity: {
    isLoading: true,
    data: null,
    error: '',
  },
  searchCounty: {
    isLoading: true,
    data: null,
    error: '',
  },
  cityLoader: {
    isLoading: true,
  },
  countyLoader: {
    isLoading: true,
  },
  charitySaved: false,
  // Charity Details
  selectedCharityName: '',
  selectedCharityAddress: '',
  selectedCharityId: '',
  selectedCharityEin: '',
  selectedCharityInterest: '',
  // Amount and Schedule
  searchNextApi: 0,
  searchCharity: {
    isLoading: true,
    data: [],
    isCharitySearch: false,
    error: '',
    guidestarSearchCount: '',
    serverDown: false,
  },
  spawns: [],
  geminiFilter: {
    showFilter: false,
  },
  from: 0,
  einData: '',
  geminiEinData: '',
  searchTerm: null,
  removeSuccessData: [],
  removeCharityData: [],
  lazyLoadingFlag: false,
  pendingGrantsLoading: false,
  pendingGrants: [],
  pendingAgreements: [],
  pendingActiveSchedule: [],
  grantSearchTerm: null,
  grantGeminiSearchTerm: null,
});

const filterGrantAgreementData = (unfilteredData) => {
  return unfilteredData.map((data) => ({
    id: data.grantAgreementId,
    remainingPayments: data.pendingPayments,
    endDate: data.gaEndDate,
  }));
};

const grantsDashboard = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.resetDataGrantType:
      return state
        .setIn(['accountData', 'data'], {})
        .setIn(['chartData', 'show'], false)
        .setIn(['chartData', 'isLoading'], false)
        .setIn(['chartData', 'data'], null)
        .setIn(['chartData', 'error'], null)
        .setIn(['currentPendingGrants', 'data'], [])
        .setIn(['issuedGrants', 'data'], [])
        .setIn(['initialPendingGrants'], 10)
        .setIn(['initialIssuedGrants'], 10)
        .setIn(['grantDashboard_data', 'data'], [])
        .setIn(['grantDashboard_data_all', 'data'], [])
        .setIn(['grantDashboard_data_all', 'isLoadingBot'], false)
        .setIn(['searchCharity', 'data'], [])
        .setIn(['searchCharity', 'guidestarSearchCount'], '')
        .setIn(['searchCharity', 'isCharitySearch'], false)
        .setIn(['recentCharities'], [])
        .setIn(['savedCharities'], [])
        .setIn(['geminiFilter', 'showFilter'], false)
        .setIn(['searchCity', 'data'], null)
        .setIn(['searchCounty', 'data'], null)
        .setIn(['grantSearchTerm'], null)
        .setIn(['searchGemini', 'data'], null)
        .setIn(['searchGemini', 'isGeminiSearch'], false);
    case actionTypes.countDataFetchLoadingType:
      return state.setIn(['grantsCount', 'isLoading'], true);
    case actionTypes.countDataSuccessType:
      return state
        .setIn(['grantsCount', 'data'], action.payload)
        .setIn(['grantsCount', 'isLoading'], false);
    case actionTypes.grantsAccountDataFetchLoadingType:
      return state.setIn(['accountData', 'isLoading'], true);
    case actionTypes.grantsAccountDataSuccessType:
      return state
        .setIn(['accountData', 'data'], action.payload)
        .setIn(['accountData', 'isLoading'], false);
    case actionTypes.lazyLoadDataLoaderType:
      return state.setIn(['isLazyLoading'], true);
    case actionTypes.lazyLoadIssuedDataSuccessType:
      return state
        .setIn(['isLazyLoading'], false)
        .setIn(['issuedGrants', 'data'], [...action.payload.issuedGrants])
        .setIn(
          ['issuedGrants', 'dataAvailableForNextRequest'],
          action.payload.dataAvailableForNextRequest
        )
        .setIn(
          ['initialIssuedGrants'],
          state.getIn(['initialIssuedGrants']) + 10
        );
    case actionTypes.lazyLoadPendingGrantsDataSuccessType:
      return state
        .setIn(['isLazyLoading'], false)
        .setIn(['currentPendingGrants', 'isLoading'], false)
        .setIn(
          ['currentPendingGrants', 'data'],
          [...action.payload.pendingGrants]
        )
        .setIn(
          ['currentPendingGrants', 'dataAvailableForNextRequest'],
          action.payload.dataAvailableForNextRequest
        )
        .setIn(
          ['initialPendingGrants'],
          state.getIn(['initialPendingGrants']) + 10
        );
    case actionTypes.currentPendingGrantsLoaderType:
      return state.setIn(['currentPendingGrants', 'isLoading'], true);
    case actionTypes.currentPendingGrantsSuccessType:
      return state
        .setIn(['currentPendingGrants', 'data'], action.payload.pendingGrants)
        .setIn(
          ['currentPendingGrants', 'isLoading'],
          !state.getIn(['currentPendingGrants', 'isLoading'])
        )
        .setIn(
          ['currentPendingGrants', 'dataAvailableForNextRequest'],
          action.payload.dataAvailableForNextRequest
        )
        .setIn(
          ['initialPendingGrants'],
          state.getIn(['initialPendingGrants']) + 10
        );
    case actionTypes.issuedGrantsLoaderType:
      return state.setIn(['issuedGrants', 'isLoading'], true);
    case actionTypes.issuedGrantsSuccessType:
      return state
        .setIn(['issuedGrants', 'data'], action.payload.issuedGrants)
        .setIn(
          ['issuedGrants', 'isLoading'],
          !state.getIn(['issuedGrants', 'isLoading'])
        )
        .setIn(
          ['issuedGrants', 'dataAvailableForNextRequest'],
          action.payload.dataAvailableForNextRequest
        )
        .setIn(
          ['initialIssuedGrants'],
          state.getIn(['initialIssuedGrants']) + 10
        );
    case actionTypes.grantsDashboardDataLoadingType:
      return state
        .setIn(['grantDashboard_data', 'isLoadingBot'], true)
        .setIn(
          ['grantDashboard_data', 'botStatusText'],
          'Searching for results in this date range'
        );
    case actionTypes.grantsDashboardDataSuccessType:
      var text = 'No data available for this date range';
      if (action.payload.length && action.payload[0].y3) {
        text = 'Searching for results in the data range';
      } else {
        text = 'No data available for this date range';
      }
      return state
        .setIn(['grantDashboard_data', 'data'], action.payload)
        .setIn(['grantDashboard_data', 'isLoadingBot'], false)
        .setIn(['grantDashboard_data', 'botStatusText'], text)
        .setIn(
          ['grantDashboard_data', 'data_y3'],
          action.payload.length ? action.payload[0].y3 : false
        )
        .setIn(
          ['grantDashboard_data', 'data_y5'],
          action.payload.length ? action.payload[0].y5 : false
        );
    case actionTypes.allGrantsDashboardDataLoadingType:
      return state.setIn(['grantDashboard_data_all', 'isLoadingBot'], true);
    case actionTypes.allGrantsDashboardDataSuccessType:
      return state
        .setIn(['grantDashboard_data_all', 'data'], action.payload)
        .setIn(['grantDashboard_data_all', 'isLoadingBot'], false)
        .setIn(
          ['grantDashboard_data', 'botStatusText'],
          'No data available for this date range'
        )
        .setIn(
          ['grantDashboard_data_all', 'data_all_y3'],
          action.payload.length ? action.payload[0].y3 : false
        )
        .setIn(
          ['grantDashboard_data_all', 'data_all_y5'],
          action.payload.length ? action.payload[0].y5 : false
        );
    case actionTypes.storeGrantChartDataLoadingType:
      return state
        .setIn(['chartData', 'isLoading'], true)
        .setIn(['chartData', 'show'], true);
    case actionTypes.storeGrantChartDataSuccessType:
      let zArray = action.payload.z;
      return state
        .setIn(['chartData', 'data'], zArray)
        .setIn(['chartData', 'isLoading'], false);
    case actionTypes.storeGrantChartDataFailedType:
      return state
        .setIn(['chartData', 'isLoading'], false)
        .setIn(['chartData', 'error'], action.payload);
    case actionTypes.disableGrantsShowType:
      return state
        .setIn(['chartData', 'show'], false)
        .setIn(['chartData', 'isLoading'], false)
        .setIn(['chartData', 'data'], null)
        .setIn(['chartData', 'error'], null);

    // charity search

    case actionTypes.searchTermType:
      return state.set('grantSearchTerm', action.payload);

    case actionTypes.geminiSearchTermType:
      return state.set('grantGeminiSearchTerm', action.payload);

    case actionTypes.fetchSavedCharitySuccessType: {
      return state
        .setIn(['savedCharities'], action.payload)
        .setIn(['savedCharity', 'isLoading'], false);
    }

    case actionTypes.submitSavedGeminiDataSuccessType: {
      let submitGeminiData = action.payload;
      const { prevData = {} } = action;
      return state
        .updateIn(['searchGemini', 'data'], (searchResults) =>
          searchResults.map((record) => {
            if (record.granteeOrgId === prevData.granteeOrgId) {
              record.isPending = action.payload.isPending;
              return {
                ...record,
                isSelected: true,
                granteeOrgAliasId: submitGeminiData.granteeOrgAliasId,
                loading: false,
              };
            }
            return { ...record };
          })
        )
        .setIn(['charitySaved'], true);
    }

    case actionTypes.submitSavedGeminiDataFailType: {
      const { prevData = {} } = action;
      return state
        .setIn(['charitySaved'], false)
        .updateIn(['searchGemini', 'data'], (searchResults) =>
          mapLoadingCancelToResults(searchResults, prevData, 'granteeOrgId')
        );
    }

    case actionTypes.postGeminiSavedDataType: {
      const { charityData = {} } = action.payload;
      return state
        .setIn(['charitySaved'], false)
        .updateIn(['searchGemini', 'data'], (searchResults) =>
          mapLoadingToResults(searchResults, charityData, 'granteeOrgId')
        );
    }

    case actionTypes.einDataType: {
      let searchData = state.getIn(['searchCharity', 'data']);
      let searchCharityData = searchData.splice(0);
      let newSearchCharity;
      newSearchCharity = searchCharityData.map((obj) => {
        if (obj.granteeOrgAliasId === action.payload) {
          obj.isSelected = false;
        }
        return obj;
      });
      return state
        .set('einData', action.payload)
        .setIn(['searchCharity', 'data'], newSearchCharity);
    }

    case actionTypes.saveCharityType: {
      const { charityData = {} } = action.payload;
      return state
        .setIn(['charitySaved'], false)
        .updateIn(['searchCharity', 'data'], (searchResults) =>
          mapLoadingToResults(searchResults, charityData, 'ein')
        );
    }

    case actionTypes.clearAllFiltersType: {
      return state.setIn(['searchCharity', 'isCharitySearch'], false);
    }

    case actionTypes.clearAllGeminiFiltersType: {
      return state.setIn(['searchGemini', 'isGeminiSearch'], false);
    }

    case actionTypes.saveCharitySuccessType: {
      const { prevData = {} } = action;
      return state
        .updateIn(['searchCharity', 'data'], (searchResults) =>
          searchResults.map((obj) => {
            if (obj.ein === prevData.ein && action.payload.success) {
              return {
                ...obj,
                charityId: action.payload.charityId,
                granteeOrgAliasId: action.payload.granteeOrgAliasId,
                isSelected: true,
                loading: false,
              };
            }
            return { ...obj };
          })
        )
        .setIn(['charitySaved'], action.payload.success);
    }

    case actionTypes.addCharitySuccessType: {
      const { prevData = {} } = action;
      return state
        .updateIn(['searchCharity', 'data'], (searchResults) =>
          searchResults.map((obj) => {
            if (obj.ein === prevData.ein && action.payload) {
              return {
                ...obj,
                charityId: prevData.granteeOrgId,
                granteeOrgAliasId: action.payload,
                isSelected: true,
                loading: false,
              };
            }
            return { ...obj };
          })
        )
        .setIn(['charitySaved'], true);
    }

    case actionTypes.saveCharityFailType:
    case actionTypes.addCharityFailType: {
      const { prevData = {} } = action;
      return state
        .setIn(['charitySaved'], false)
        .updateIn(['searchCharity', 'data'], (searchResults) =>
          mapLoadingCancelToResults(searchResults, prevData, 'ein')
        );
    }

    case actionTypes.cancelSaveCharityType: {
      const prevData = action.payload;
      return state
        .setIn(['charitySaved'], false)
        .updateIn(['searchCharity', 'data'], (searchResults) =>
          mapLoadingCancelToResults(searchResults, prevData, 'ein')
        );
    }

    case actionTypes.searchCharityResponseType: {
      let prevData = state.getIn(['searchCharity', 'data']);
      let lazyLoadingFlag = state.get('lazyLoadingFlag');
      let searchSavedData = state.getIn(['savedCharities']);
      const searchCharityResponse = action.payload.hits;
      const { serverDown } = action.payload;
      if (prevData === null) {
        // sonar issue: Might be required in future
        // if (searchSavedData.length === 0) {
        //   prevData &&
        //     prevData.forEach((record) => {
        //       record.isSelected = false;
        //     });
        // }

        loop1: for (let i = 0; i < searchSavedData.length; i++) {
          loop2: for (let j = 0; j < searchCharityResponse.length; j++) {
            if (searchSavedData[i].ein === searchCharityResponse[j].ein) {
              searchCharityResponse[j].isSelected = true;
              searchCharityResponse[j].granteeOrgAliasId =
                searchSavedData[i].granteeOrgAliasId;
              searchCharityResponse[j].charityId = searchSavedData[i].charityId;
              searchCharityResponse[j].isPending = searchSavedData[i].isPending;
              break loop2;
            }
          }
        }
        searchCharityResponse.forEach((item) => {
          if (!item.isSelected) {
            item.isSelected = false;
          }
        });

        return state
          .setIn(['searchCharity', 'data'], searchCharityResponse)
          .setIn(
            ['searchCharity', 'guidestarSearchCount'],
            action.payload.total_hits
          )
          .setIn(['searchCharity', 'isLoading'], false)
          .setIn(["searchCharity", "serverDown"], serverDown)
          .setIn(['searchCharity', 'isCharitySearch'], true);
      } else {
        if (searchSavedData.length === 0) {
          searchCharityResponse.forEach((record) => {
            record.isSelected = false;
          });
        }
        if (searchCharityResponse.length > 0) {
          loop1: for (let i = 0; i < searchSavedData.length; i++) {
            loop2: for (let j = 0; j < searchCharityResponse.length; j++) {
              if (searchSavedData[i].ein === searchCharityResponse[j].ein) {
                searchCharityResponse[j].isSelected = true;
                searchCharityResponse[j].granteeOrgAliasId =
                  searchSavedData[i].granteeOrgAliasId;
                searchCharityResponse[j].charityId =
                  searchSavedData[i].charityId;
                searchCharityResponse[j].isPending =
                  searchSavedData[i].isPending;
                break loop2;
              }
            }
          }
        }
        searchCharityResponse.forEach((item) => {
          if (!item.isSelected) {
            item.isSelected = false;
          }
        });

        if (lazyLoadingFlag === true) {
          for (let i = 0; i < searchCharityResponse.length; i++) {
            prevData = [...prevData, searchCharityResponse[i]];
          }
          return state
            .setIn(['searchCharity', 'data'], prevData)
            .setIn(
              ['searchCharity', 'guidestarSearchCount'],
              action.payload.total_hits
            )
            .setIn(['searchCharity', 'isLoading'], false)
            .setIn(['searchCharity', 'isCharitySearch'], true)
            .setIn(["searchCharity", "serverDown"], serverDown)
            .set('lazyLoadingFlag', false);
        }

        return state
          .setIn(['searchCharity', 'data'], searchCharityResponse)
          .setIn(
            ['searchCharity', 'guidestarSearchCount'],
            action.payload.total_hits
          )
          .setIn(['searchCharity', 'isLoading'], false)
          .setIn(["searchCharity", "serverDown"], serverDown)
          .setIn(['searchCharity', 'isCharitySearch'], true);
      }
    }

    case actionTypes.searchCharityErrorResponseType: {
      return state;
    }

    case actionTypes.selectCharityType: {
      const { id, name, address, ein, interestArea } = action.payload;
      return state
        .setIn(['selectedCharityId'], id)
        .setIn(['selectedCharityName'], name)
        .setIn(['selectedCharityAddress'], address)
        .setIn(['selectedCharityEin'], ein)
        .setIn(['selectedCharityInterest'], interestArea);
    }

    case actionTypes.makeScheduleAllocationType: {
      const {
        grantAmount,
        userSelectedDateVal,
        startDate,
        frequency,
        noOfPayments,
        scheduleType,
        allocationPref,
        allocations,
      } = action.payload;
      return state
        .setIn(['grantAmount'], grantAmount)
        .setIn(['startDate'], startDate)
        .setIn(['userSelectedDateVal'], userSelectedDateVal)
        .setIn(['frequency'], frequency)
        .setIn(['noOfPayments'], noOfPayments)
        .setIn(['scheduleType'], scheduleType)
        .setIn(['allocationType'], allocationPref)
        .setIn(['allocations'], allocations);
    }

    case actionTypes.updateFromCounterWorkerType: {
      const nextCounter = state.getIn(['searchNextApi']) + action.payload;
      return state.setIn(['searchNextApi'], nextCounter);
    }

    case actionTypes.geminiFilterType: {
      return state.setIn(['geminiFilter', 'showFilter'], action.payload);
    }

    case fetchGrantHistorySuccessType: {
      const { grantsForCharity = {} } = action.payload;
      const { grants = [] } = grantsForCharity;
      return state.setIn(['grantHistory'], grants);
    }

    case actionTypes.updateFromType:
      let prevValue = state.get('from');
      prevValue = prevValue + 25;

      return state.set('from', prevValue).set('lazyLoadingFlag', true);

    case actionTypes.searchTermType:
      return state.set('searchTerm', action.payload);

    case actionTypes.searchGeminiResponseType: {
      const searchSavedData = state.getIn(['savedCharities']);
      if (typeof action.payload === 'string') {
        return state
          .setIn(['searchGemini', 'searchGeminiStringResponse'], action.payload)
          .setIn(['searchGemini', 'data'], [])
          .setIn(['searchGemini', 'isLoading'], false)
          .setIn(['searchGemini', 'isGeminiSearch'], true);
      }
      if (action.payload.length > 0) {
        action.payload.forEach((record) => {
          if (record.granteeOrgAliasId !== 0) {
            record.isSelected = false;
            const savedCharityMatch = find(searchSavedData, {
              charityId: parseInt(record.granteeOrgId),
            });
            if (savedCharityMatch) {
              record.isPending = savedCharityMatch.isPending;
              record.charityId = savedCharityMatch.charityId;
              record.isSelected = true;
              record.granteeOrgAliasId = savedCharityMatch.granteeOrgAliasId;
            }
          } else {
            record.isSelected = false;
          }
        });
      }
      return state
        .setIn(['searchGemini', 'data'], action.payload)
        .setIn(['searchGemini', 'searchGeminiStringResponse'], '')
        .setIn(['searchGemini', 'isLoading'], false)
        .setIn(['searchGemini', 'isGeminiSearch'], true);
    }

    case actionTypes.geminiEinDataType: {
      let searchData = state.getIn(['searchGemini', 'data']);
      let searchGeminiData = searchData.splice(0);
      let newSearchGemini;
      newSearchGemini = searchGeminiData.map((obj) => {
        if (obj.ein && obj.ein === action.payload) {
          obj.isSelected = false;
        }
        return obj;
      });
      return state
        .set('geminiEinData', action.payload)
        .setIn(['searchGemini', 'data'], newSearchGemini);
    }

    case actionTypes.cityLoaderType:
      return state.setIn(['cityLoader', 'isLoading'], false);

    case actionTypes.searchCityResponseType:
      return state
        .setIn(['searchCity', 'data'], action.payload)
        .setIn(['searchCity', 'isLoading'], false)
        .setIn(['cityLoader', 'isLoading'], false);

    case actionTypes.searchCountySuccessResponseType:
      return state
        .setIn(['searchCounty', 'data'], action.payload)
        .setIn(['searchCounty', 'isLoading'], false)
        .setIn(['countyLoader', 'isLoading'], false);

    case actionTypes.updateFromCounterWorkerType:
      let nextCounter = state.get('searchNextApi', action.payload.payload);
      nextCounter = nextCounter + 1;
      return state.set('searchNextApi', nextCounter);

    case actionTypes.updateFromLoadMoreCounterWorkerType:
      let nextLoadMoreCounter = state.get(
        'searchLoadMoreApi',
        action.payload.payload
      );

      nextLoadMoreCounter = nextLoadMoreCounter + 10;

      return state.set('searchLoadMoreApi', nextLoadMoreCounter);

    case actionTypes.fetchPendGrantType: {
      return state
        .setIn(['pendingGrantsLoading'], true)
        .setIn(['pendingGrants'], [])
        .setIn(['pendingAgreements'], [])
        .setIn(['pendingActiveSchedule'], []);
    }
    case actionTypes.fetchPendGrantSuccessType: {
      const { grantsForCharity = {} } = action.payload;
      const {
        grants = [],
        activeSchedule = [],
        activeGrantAgreement = [],
      } = grantsForCharity;

      return state
        .setIn(['pendingGrantsLoading'], false)
        .setIn(['pendingGrants'], grants)
        .setIn(
          ['pendingAgreements'],
          filterGrantAgreementData(activeGrantAgreement)
        )
        .setIn(['pendingActiveSchedule'], activeSchedule);
    }
    case actionTypes.fetchPendGrantFailType: {
      return state
        .setIn(['pendingGrantsLoading'], false)
        .setIn(['pendingGrants'], [])
        .setIn(['pendingAgreements'], [])
        .setIn(['pendingActiveSchedule'], []);
    }
    case actionTypes.resetSavedCharityFlagType: {
      return state.setIn(['savedCharity', 'isLoading'], action.payload);
    }
    case actionTypes.removeCharitySuccessType: {
      if (action.payload.payload.searchType === 'gemini') {
        const searchGemini = state.getIn(['searchGemini', 'data']);
        if (searchGemini && searchGemini.length) {
          searchGemini.forEach((data) => {
            if (
              data.granteeOrgAliasId &&
              data.granteeOrgAliasId === action.payload.payload.charityId
            ) {
              data.isPending = false;
              data.isSelected = false;
            }
          });
        }
        return state.setIn(['searchGemini', 'data'], searchGemini);
      } else {
        let searchData = state.getIn(['searchCharity', 'data']);
        if (searchData && searchData.length) {
          searchData.forEach((data) => {
            if (
              data.granteeOrgAliasId &&
              data.granteeOrgAliasId === action.payload.payload.charityId
            ) {
              data.isPending = false;
              data.isSelected = false;
            }
          });
        }
        return state.setIn(['searchCharity', 'data'], searchData);
      }
    }

    default:
      return state;
  }
};

export default grantsDashboard;
